import script from "./UiDatePicker.vue?vue&type=script&lang=ts&setup=true"
export * from "./UiDatePicker.vue?vue&type=script&lang=ts&setup=true"

import "./UiDatePicker.vue?vue&type=style&index=0&id=6ebc44c0&lang=css"

const __exports__ = script;

export default __exports__